const getUploadHttpStatus = (error) =>
  error?.response?.status ?? error?.request?.status ?? null

export const isUnsupportedMediaTypeError = (error) =>
  getUploadHttpStatus(error) === 415

export default getUploadHttpStatus
